import api from "./api";
import apiEndPoints from "./end-point";
import axiosBaseQuery from './axiosBaseQuery'
export { api, apiEndPoints }